"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateType = exports.generateValidator = exports.Ajv = void 0;
const ajv_1 = __importDefault(require("ajv"));
exports.Ajv = ajv_1.default;
const ajv_keywords_1 = __importDefault(require("ajv-keywords"));
const ajv_errors_1 = __importDefault(require("ajv-errors"));
/**
 * Generates a validator for a specific JSON schema of a type T
 * @public
 */
function generateValidator(schema, keywordDefinitions) {
    const ajv = new ajv_1.default({ $data: true, allErrors: true });
    (0, ajv_keywords_1.default)(ajv);
    (0, ajv_errors_1.default)(ajv, { singleError: true });
    keywordDefinitions === null || keywordDefinitions === void 0 ? void 0 : keywordDefinitions.forEach((kw) => ajv.addKeyword(kw));
    return ajv.compile(schema);
}
exports.generateValidator = generateValidator;
/**
 * Validates a type with a schema in a functional way.
 * @public
 */
function validateType(theType, value) {
    return theType.validate(value);
}
exports.validateType = validateType;
//# sourceMappingURL=validation.js.map